/**
 * Coup de pouce — Attendu 1099 « savoir qu'une fraction est aussi le quotient :
 * 7 × 3/7 = 3 » (automatisme 4e, l. 655). UNE page STATIQUE partagée par les
 * trois generator_keys.
 *
 * L'image que l'élève a déjà : la barre de 1049 (5e), une longueur coupée en
 * parts égales étiquetées avec la fraction. Ici la barre vaut 3, coupée en
 * 7 parts égales étiquetées 3/7 : la vérification de 1049 (« 4 parts de
 * 13/4, ça fait bien 13 ») devient LE geste. Résultat en gros « 7 × 3/7 =
 * 3 », une ligne en langue d'élève : « 7 parts de 3/7, ça fait la barre
 * entière : 3. » Rien à multiplier, rien à simplifier.
 *
 * SACRIFIÉ : (7 ; 3), l'exemple du programme, sous tous ses ordres
 * (gen_1099, COUPLE_SACRIFIE, auto-testé par gen1099.self.test.js).
 * Largeur bornée à 340 px, tailles de 1048, texte dans la figure.
 */

const ORANGE = '#EA580C';
const ORANGE_CLAIR = '#FED7AA';
const BLEU = '#2563EB';
const VERT = '#15803D';
const GRIS = '#E2E8F0';
const ENCRE = '#1E293B';

const XB = 30;
const WB = 343;
const NB = 7;
const WM = WB / NB;

/** Une fraction empilée, une couleur. */
const frac = (x, y, n, d, couleur, taille, demi) => `
  <text x="${x}" y="${y - 4}" font-size="${taille}" font-weight="bold" text-anchor="middle" fill="${couleur}">${n}</text>
  <line x1="${x - demi}" y1="${y}" x2="${x + demi}" y2="${y}" stroke="${couleur}" stroke-width="1.8"/>
  <text x="${x}" y="${y + taille + 1}" font-size="${taille}" font-weight="bold" text-anchor="middle" fill="${couleur}">${d}</text>`;

const PARTS = Array.from({ length: NB }, (_, k) => {
    const x = XB + k * WM;
    return `<rect x="${x}" y="96" width="${WM}" height="36" fill="${ORANGE_CLAIR}" stroke="${ORANGE}" stroke-width="2"/>
  ${frac(x + WM / 2, 114, 3, 7, ORANGE, 10, 8)}`;
}).join('\n  ');

const SVG_PARTS = `
<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 400 258" width="100%" style="max-width:340px;height:auto;display:block" role="img"
     aria-label="7 fois 3 sur 7 égale combien ? Une barre entière de 3, et dessous la même longueur coupée en 7 parts égales, chacune étiquetée 3 sur 7. 7 fois 3 sur 7 égale 3. 7 parts de 3 sur 7, ça fait la barre entière : 3.">
  <text x="182" y="32" font-size="16" font-weight="bold" text-anchor="end" fill="${ENCRE}"><tspan fill="${BLEU}">7</tspan> ×</text>
  ${frac(200, 26, 3, 7, ORANGE, 12, 9)}
  <text x="218" y="32" font-size="16" font-weight="bold" fill="${ENCRE}">= ?</text>
  <rect x="${XB}" y="48" width="${WB}" height="36" fill="${GRIS}" stroke="${ENCRE}" stroke-width="1.5"/>
  <text x="200" y="73" font-size="15" font-weight="bold" text-anchor="middle" fill="${VERT}">3</text>
  ${PARTS}

  <!-- le résultat -->
  <text x="168" y="180" font-size="18" font-weight="bold" text-anchor="end" fill="${ENCRE}"><tspan fill="${BLEU}">7</tspan> ×</text>
  ${frac(188, 173, 3, 7, ORANGE, 15, 12)}
  <text x="206" y="180" font-size="18" font-weight="bold" fill="${ENCRE}">= <tspan fill="${VERT}">3</tspan></text>

  <!-- le geste -->
  <text x="128" y="226" font-size="12" text-anchor="end" fill="${ENCRE}"><tspan font-weight="bold" fill="${BLEU}">7</tspan> parts de</text>
  ${frac(142, 221, 3, 7, ORANGE, 10, 7)}
  <text x="156" y="226" font-size="12" fill="${ENCRE}">, ça fait la barre entière : <tspan font-weight="bold" fill="${VERT}">3</tspan>.</text>
  <text x="200" y="246" font-size="12" text-anchor="middle" fill="${ENCRE}">Rien à multiplier : je l'écris.</text>
</svg>`.trim();

const AIDE = { pages: [{ titre: '7 parts de 3/7', svg: SVG_PARTS }] };

const CP_1099 = {
    flash_texte_trou_saisie: AIDE,
    nombre_qcm_unique: AIDE,
    sens_tableau_vf: AIDE,
};

export default CP_1099;
